import React, { useEffect } from 'react'
import { RouteProps } from 'react-router'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import Loader from '../../components/Loader'
import { actions, selectors } from '../../redux'
import { routesPath } from '../../router'

const AuthCallback: React.FC<RouteProps> = () => {
  const dispatch = useDispatch()
  const [searchParams] = useSearchParams()
  const institution = useSelector(selectors.institutions.institution)
  const login = useSelector(selectors.auth.login)
  const navigate = useNavigate()

  useEffect(() => {
    const code = searchParams.get('code')

    if (code && institution) {
      dispatch(actions.auth.socialLoginRequest({ code, institution: institution.id }))
    } else {
      throw new Error('Code or institution could not be found')
    }

    return () => {
      dispatch(actions.auth.socialLoginReset())
    }
  }, [dispatch, searchParams, institution])

  useEffect(() => {
    if (login.errors) {
      navigate(routesPath.onboarding)
    }
  }, [login, navigate])

  return <Loader />
}

export default AuthCallback
